import React, {useEffect, useState} from "react";
import {ConfirmModal, useNotifications} from "peggirkit";
import {SetStateFn} from "@/utils/SetStateUtils";
import {FormattedMessage, useIntl} from "react-intl";
import {notifyDanger, notifySuccess} from "@/utils/NotifyUtils";
import {globalConfirmModalProps} from "@/utils/ModalUtils";
import {useRestaurant} from "@/context/restaurant/RestaurantProvider";
import {api} from "@/data/api";

type Props = {
    show: boolean,
    setShow: SetStateFn<boolean>,
    setShowSynchronizationBusyModal: SetStateFn<boolean>,
};

const SynchronizeMenu = ({show, setShow, setShowSynchronizationBusyModal}: Props) => {
    const intl = useIntl();
    const {notify} = useNotifications();
    const [loading, setLoading] = useState(false);
    const {dashboardLocation} = useRestaurant();

    // TODO - Retrieve with Tanstack
    // Request synchronisation
    useEffect(() => {
        if (!loading)
            return;

        api.sync.syncMenu(dashboardLocation.id)
            .then((res) => {
                setLoading(false);
                setShow(false);

                if (res.message === "Synchronization busy.") {
                    setShowSynchronizationBusyModal(true);
                    return;
                }

                notifySuccess(intl.formatMessage({id: "synchronizationRequested"}), notify);
            })
            .catch((e) => {
                console.log(e);
                setLoading(false);
                notifyDanger(intl.formatMessage({id: "systemError"}), notify);
            });
    }, [loading, setLoading, setShow, intl, notify, setShowSynchronizationBusyModal, dashboardLocation]);

    return (
        <ConfirmModal
            {...globalConfirmModalProps(intl)}
            show={show}
            onClose={() => setShow(false)}
            title={intl.formatMessage(
                {id: "menuSyncConfirm"},
                {location: dashboardLocation.name}
            )}
            type={"info"}
            continueButton={{
                text: intl.formatMessage({id: "continue"}),
                onClick: () => setLoading(true),
            }}
            disabled={loading}
            loading={loading}
        >
            <FormattedMessage
                id={"menuSyncConfirm.description"}
                values={{
                    location: (
                        <strong className={"font-bold"}>
                            {dashboardLocation.name}
                        </strong>
                    ),
                }}
            />
        </ConfirmModal>
    );
};

export default SynchronizeMenu;